import React from 'react'
import PropTypes from 'prop-types'
import './Pagination.css'
import { isBoolean } from 'lodash'

const defaultButton = props => <button {...props}>{props.children}</button>
defaultButton.propTypes = {
  children: PropTypes.any
}
export default class Pagination extends React.Component {
  constructor(props) {
    super()
    this.changePage = this.changePage.bind(this)
    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages)
    }
  }

  static propTypes = {
    children: PropTypes.any,
    pages: PropTypes.number,
    page: PropTypes.number,
    data: PropTypes.array,
    pageSize: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.any,
    firstPageText: PropTypes.any,
    lastPageText: PropTypes.any,
    nextText: PropTypes.any,
    showPageSizeOptions: PropTypes.bool,
    onPageSizeChange: PropTypes.func,
    pageSizeOptions: PropTypes.array,
    showPaginationText: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.node
    ])
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages)
      })
    }

    this.changePage(nextProps.page + 1)
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages)
  };

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total)
    }
    else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total]
      }
      else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total]
      }
      else {
        return [1, 2, 3, 4, 5, total]
      }
    }
  };

  changePage(page) {
    const activePage = this.props.page + 1

    if (page === activePage) {
      return
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages)

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    })

    this.props.onPageChange(page - 1)
  }

  getPageSizeOption() {
    const { pageSizeOptions, onPageSizeChange, pageSize } = this.props
    return (
      <span style={{ marginLeft: 5 }} className="select-wrap -pageSizeOptions">
        <select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize}>
          {pageSizeOptions.map((option, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <option key={i} value={option}>
              {option} {this.props.rowsText}
            </option>
          ))}
        </select>
      </span>
    )
  }

  showPaginationText = () => {
    const { pages, showPaginationText } = this.props
    const activePage = this.props.page + 1
    if (isBoolean(showPaginationText) && showPaginationText) {
      return (
        <div className='Table__Pages'>
          { typeof pages === 'string' && pages.toUpperCase() === 'UNKNOWN' ? `Page ${activePage}` : `Page ${activePage} of ${pages}` }
        </div>
      )
    }

    if (React.isValidElement(showPaginationText)) {
      return showPaginationText
    }
    return null
  }

  getTotalCalculation = () => {
    const { pageSize, page, pages, totalRows } = this.props
    let rowsFrom = 1
    if (page > 0) {
      rowsFrom = (pageSize * page) + 1
    }
    const totalNumberOfRows = totalRows ? totalRows : pageSize * pages
    const activePage = page + 1
    return `${rowsFrom} to ${activePage * pageSize <= totalNumberOfRows ? (activePage) * pageSize : totalNumberOfRows} of ${totalNumberOfRows}`
  }

  render() {
    const { PageButtonComponent = defaultButton, showPageSizeOptions, showTotal, paginationLeftCmp, paginationRightCmp } = this.props
    // const { visiblePages } = this.state
    const activePage = this.props.page + 1

    return (
      <div className="Table__pagination">
        <div className="Table__pagination_left">
          {paginationLeftCmp}
        </div>
        {showTotal ? <div className='Table__Pages'>
          {this.getTotalCalculation()}
        </div> : null }
        {showPageSizeOptions ? this.getPageSizeOption() : null }
        <div className="Table__prevPageWrapper">
          <PageButtonComponent disabled={activePage === 1} className="Table__pageButton" onClick={() => {
            if (activePage === 1) return
            this.changePage(0)
          }}>
            {this.props.firstPageText}
          </PageButtonComponent>
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === 1) return
              this.changePage(activePage - 1)
            }}
            disabled={activePage === 1}
          >
            {this.props.previousText}
          </PageButtonComponent>
        </div>
        {this.showPaginationText()}
        <div className="Table__nextPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === this.props.pages) return
              this.changePage(activePage + 1)
            }}
            disabled={activePage === this.props.pages}
          >
            {this.props.nextText}
          </PageButtonComponent>
          <PageButtonComponent className="Table__pageButton"
            onClick={() => {
              if (activePage === this.props.pages) return
              this.changePage(this.props.pages)
            }}
            disabled={activePage === this.props.pages}>
            {this.props.lastPageText}
          </PageButtonComponent>
        </div>
        {paginationRightCmp}
      </div>
    )
  }
}

Pagination.defaultPropTypes = {
  previousText: '<',
  firstPageText: '<<',
  lastPageText: '>>',
  nextText: '<',
  showPaginationText: true,
}

